var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/home/parts/maptonavigationmodel',["require", "exports", "common/parts", "common/triple", "common/string", "areas/home/model/dto", "areas/home/viewmodels/datatile", "services/settings"], function (require, exports, Parts, Triple, Strings, Model, Tile, Configuration) {
    "use strict";
    var MapToNavigationModel = (function (_super) {
        __extends(MapToNavigationModel, _super);
        function MapToNavigationModel() {
            _super.apply(this, arguments);
            this.cdnEndPoint = Configuration.Settings.environment.getCustomValue("CdnEndPoint");
        }
        MapToNavigationModel.prototype.process = function (symbol) {
            var modules = symbol.item1;
            var root = symbol.item2;
            var result = this.map(null, root, modules);
            this.output.call(new Triple(root, modules, result));
        };
        MapToNavigationModel.prototype.map = function (root, node, modules) {
            var _this = this;
            var imagePath = "";
            var imagePathSearchbar = "";
            if (node.data.imagePath) {
                imagePath = node.data.imagePath.indexOf("/") === 0 ? node.data.imagePath.substring(1) : node.data.imagePath;
                imagePath = this.cdnEndPoint + imagePath.replace("html/content/images/", "content/images/");
            }
            if (node.data.imagePathSearchbar) {
                imagePathSearchbar = node.data.imagePathSearchbar.indexOf("/") === 0 ? node.data.imagePathSearchbar.substring(1) : node.data.imagePathSearchbar;
                imagePathSearchbar = this.cdnEndPoint + imagePathSearchbar.replace("html/content/images/", "content/images/");
            }
            var result = new Model.NavigationNode();
            result.type = node.data.type;
            result.name = node.data.name.replace(/&amp;/g, '&');
            result.isHidden = node.data.isHidden || false;
            result.icon = node.data.icon || null;
            result.color = node.data.color || null;
            result.openInDialog = node.data.openInDialog || false;
            result.openLinkInCurrentTab = node.data.openLinkInCurrentTab || false;
            result.disableNavigateToFirstChild = node.data.disableNavigateToFirstChild || false;
            result.key = node.data.key || null;
            result.showOnMobile = node.data.showOnMobile || false;
            result.useImage = node.data.useImage || false;
            result.imagePath = imagePath;
            result.imagePathSearchbar = imagePathSearchbar;
            result.permissionId = node.data.permissionId || null;
            result.template = Strings.isNullOrEmpty(node.data.template) ? "default" : node.data.template;
            result.datakey = node.data.datakey;
            result.groupId = node.data.groupId == null ? "" : node.data.groupId.toString();
            result.groups = this.mapGroups(node.groups);
            result.index = parseInt(node.data.index);
            result.parent = root;
            if (node.data.defaultData != null && node.data.defaultData != "" && this.isJson(node.data.defaultData)) {
                result.defaultData = JSON.parse(node.data.defaultData);
            }
            result.raw = node;
            result.application = result.type !== "Application"
                ? null
                : Enumerable.From(modules).FirstOrDefault(null, function (m) { return m.templateId.toLocaleLowerCase() == node.data.uID.toLocaleLowerCase(); });
            result.uri.fragment = this.buildFragment(result);
            result.uri.path = (root == null ? "" : root.uri.absolute);
            result.thumbnail = this.buildThumbnailPath(result);
            // Counters tile navigation parameters
            if (result.name === "Digital Data Review") {
                result.firstCounterQueryString = "?status=All";
                result.secondCounterQueryString = "?status=Client completed";
            }
            if (result.type === "Application")
                result.shopId = node.data.uID;
            else
                result.shopId = null;
            // live data handling
            result.liveTileHandler = new Tile(result);
            // childs
            var childs = new Array();
            Enumerable.From(node.children)
                .ForEach(function (child) {
                var item = _this.map(result, child, modules);
                if (item != null)
                    childs.push(item);
            });
            result.children = Enumerable.From(childs).OrderBy(function (x) { return x.index; }).ToArray();
            return result;
        };
        MapToNavigationModel.prototype.mapGroups = function (source) {
            var result = new Array();
            Enumerable.From(source)
                .ForEach(function (gr) {
                var group = new Model.NavigationGroup();
                group.key = gr.key;
                group.title = gr.title;
                group.description = gr.description;
                group.index = gr.index;
                group.autoSelectIndex = gr.autoSelectIndex;
                group.icon = gr.icon;
                group.useImage = gr.useImage;
                group.imagePath = gr.imagePath;
                group.showAddWidgets = gr.showAddWidgets;
                group.hideFromSidenav = gr.hideFromSidenav;
                group.showOnMobile = gr.showOnMobile;
                group.alwaysShowTiles = gr.alwaysShowTiles;
                result.push(group);
            });
            return result;
        };
        MapToNavigationModel.prototype.isJson = function (json) {
            try {
                JSON.parse(json);
            }
            catch (e) {
                return false;
            }
            return true;
        };
        MapToNavigationModel.prototype.buildFragment = function (node) {
            var segment = node.type == "UserType" ? "" : node.name;
            //TODO: testweise entfernt: Damit wird immer der Name aus dem Nav-Baum genommen und nicht der der App.
            //if (node.type == "Application" && node.raw.children.length == 0) {
            //	var app = node.application;
            //	if (app != null) segment = app.name;
            //}
            return segment.replace(/ /g, "").replace(/\//g, "").toLowerCase();
        };
        MapToNavigationModel.prototype.buildThumbnailPath = function (node) {
            var path = "/thumbnails/performance_monitor.png";
            if (node.type == "Application") {
                var app = node.application;
                if (app != null)
                    path = app.imagePath;
            }
            return path;
        };
        return MapToNavigationModel;
    }(Parts.Part));
    return MapToNavigationModel;
});

